import UserInformation from "@svg/new-design/user-information";
import MobileTabHeading from "./MobileTabHeading";
import { ReactNode } from "react";

const MobileAboutPanel = ({
  instructorName,
  parsedContent,
}: {
  instructorName: string;
  parsedContent: ReactNode;
}) => {
  return (
    <div className="py-6">
      <MobileTabHeading
        icon={UserInformation}
        title={`درباره ${instructorName}`}
      />
      <div className="body-sm text-fds-secondary pt-4">{parsedContent}</div>
    </div>
  );
};

export default MobileAboutPanel;
